import React from 'react'
import {Row, Col, H5, Paragraph, AutoApprovedFilledIcon, ButtonPrimary} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {primary} from '@modifi/colors'
import {DialogCloseAction} from '@modifi/plugin-dialogs/lib/esm/types'

type AccountSetupCompleteDialogProps = {
  params: {sectionName: string}
  closeDialog: () => DialogCloseAction
}

const AccountSetupCompleteDialog: React.FC<AccountSetupCompleteDialogProps> = ({
  closeDialog,
  params,
}) => {
  const {t} = useTranslation('charon')

  const {sectionName} = params

  return (
    <>
      <Row alignItems="center" justifyContent="center">
        <Col auto>
          <AutoApprovedFilledIcon height={32} width={32} color={primary} />
        </Col>
        <Col auto>
          <H5>{t(`${sectionName}.account-setup-complete-dialog.headline`)}</H5>
        </Col>
      </Row>
      <Paragraph mt={16} mb={40}>
        {t(`${sectionName}.account-setup-complete-dialog.description`)}
      </Paragraph>
      <ButtonPrimary data-target="close-account-setup-dialog" onClick={closeDialog} block>
        {t(`${sectionName}.account-setup-complete-dialog.cta.label`)}
      </ButtonPrimary>
    </>
  )
}

export default AccountSetupCompleteDialog
